import { html } from 'lit/html.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
// Icon
import logo from 'url:./auc.svg'
import plus from 'url:view-base/type-icon/plus-new.svg'
import minus from 'url:view-base/type-icon/minus-new.svg'
//import icon from 'view-base/type-icon-color/toxizitaetsrisiko.svg'
import { uri } from '../data-util'
import langs from './language.json'
import * as immu from 'object-path-immutable'
import 'view-base/unit-button'
import 'view-base/unit-link'
// Text Creator
import textKinetic from './textKinetic'
import textPredict from './textPredict'
import textSection from './textSection'
import textTable from './textTable'
// Generic helper
import * as util from '../view-advice-util'
import { provider } from './provider'

// ----------------------------------------------
// Creator of text for view adivce and params
// drugs, rules, faqs come as ObjectById
// ----------------------------------------------
export function text( xeon, state = {} ) {

  // ---------------------------------
  // Preparation
  // ---------------------------------
  // Set dictionary appropiate for lang
  const lang = uri.lang()
  const dict = langs[ lang ]
  const data = provider( xeon )
  // Replace drugs
  const redu = util.replaceDrugs( dict.place1, dict.place2, lang )
  // Good working list with all the required info
  const items = data.list( lang )
  // Toggle pharmakokinetic parameters
  const { icon, more } = state.kinetic
  const svgi = more ? minus : plus
  // ------------------------------
  // Abort for Case: no wirkstoff
  // ------------------------------
  if ( Object.values( xeon.drugs ).length == 0 ) {
    return html `
      <div class="box kinetic">
        <h2>
          <img src="${logo}" alt="${dict.alt}"/>
          <span>${dict.title}</span>
          <span style="flex:1"></span>
        </h2>
        <p style="margin-top:1.5rem;">${dict.case0}</p>
      </div>
    `
  }

  // ---------------------------------------------------
  // Collect all html templates
  const htmls = []

  // Empfehlung specific change of exposure for drugs
  const empfehlung = []
  // Bewertung will provide general pharmakokinetic info
  const bewertung = []
  // Special object for evaluation of interactions
  const special = data.special( lang )

  // -------------------------------
  // Case 1 and Develop in thunk/rules
  // -------------------------------
  if ( Object.keys( items ).length == 0 ) {
    empfehlung.push( dict.case0 )
  } else {
    empfehlung.push( textPredict( dict, items, lang ) )
  }

  // ------------------------------
  // Case 1-n Bewertung
  // ------------------------------
  const kinetic = []
  for ( const { name, rule } of items ) {
    // Start new chapte newline
    if( kinetic.length > 0) {
      kinetic.push( `<br><span style="display:block;height:.6rem;"></span>` )
    }
    // Use params to create intersting kinetic text and marker
    // is list of cyps to be colored
    const marker = []
    for ( const taeter in special ) {
      if ( name != taeter ) {
        marker.push( ...Object.keys( special[ taeter ][ "inhibit" ] ) )
        marker.push( ...Object.keys( special[ taeter ][ "induces" ] ) )
      }
    }
    const texte = textKinetic( dict, rule, marker, lang )
    // Find intersection of modifier with other substrates
    const text = textSection( dict, name, special )
    // Emphasize drug name
    kinetic.push( redu( name, texte ) )
    kinetic.push( redu( name, text ) )
  }
  bewertung.push( ...kinetic)

  // --------------------------------------------------
  // Final rendering
  // --------------------------------------------------
  // Always same intro

  return html `
    <div class="box kinetic">
      <h2>
        <img src="${logo}" alt="${dict.alt}"/>
        <span>${dict.title} </span>
        ${ util.build.up("abridge") }
        <span style="flex:1"></span>
        ${ util.build.hub( `docs/kinetic/${lang}/`)}
        <span class=bar></span>
        ${ util.build.copy( "kinetic") }
        <span class=bar></span>
        <span class=score>-${provider(xeon).score()}%</span>
      </h2>
      <section class=wide>
        ${ textTable(xeon) }
      </section>
      <p>
        <span>${unsafeHTML(empfehlung.join(" "))}</span>
      </p>
      <p style="display:flex;">
        <span>${util.capitalize( dict.bew_intro)}</span>
        <span hidden="${!icon}" style="display:block;border-right: 1px solid #ccc;margin: 0 .5rem;"></span>
        <unit-svg id=kinetic class="more" hidden="${!icon}" .state="${{
          src: svgi, cursor: "pointer", fill: "#6CBCFF"
        }}"></unit-svg>
      </p>
      ${
        !more ? '' : html`
        <p>
          <span>${unsafeHTML(bewertung.join(" "))}</span>
        </p>
        `
      }
    </div>
  `
}
